import CreateBusiness from '@/views/factoring/CreateBusiness.vue'
import BeforeFacture from '@/views/factoring/BeforeFacture.vue'
import Stats from '@/views/factoring/Stats.vue'
import PersonalData from '@/views/factoring/NewMyinfo.vue'

export default [
  {
    path: 'estadisticas',
    name: 'stats',
    component: Stats,
  },
  {
    path: 'anticipo-facturas',
    name: 'anticipo-facture',
    component: BeforeFacture,
	},
	//Profile stuffs
  {
    path: 'cuenta-banco',
    name: 'My-info-acount-bank',
    component: () => import(/* webpackChunkName: "bank-account" */ '@/views/factoring/NewMyinfo.vue'),
  },
  {
    path:'mis-claves',
    name: 'My-keys-acount-bank',
    component: () => import(/* webpackChunkName: "bank-account" */ '@/views/factoring/Mypass.vue'),
  },
  {
    path: 'createbussiness',
    name: 'create-bussiness',
    component: CreateBusiness,
    props: true,
  },
  {
    path: 'empresas',
    name: 'bussiness',
    component: () => import(/* webpackChunkName: "busines" */ '@/views/factoring/Business.vue'),
  },
  {
    path: 'mis-operaciones',
    name: 'my-operation-request',
    component: () => import(/* webpackChunkName: "busines" */ '@/views/factoring/MyOperationsRequests.vue'),
  },
  {
    path: 'ceder-facturas',
    name: 'ceder-facture',
    component: () => import(/* webpackChunkName: "bank-account" */ '@/views/factoring/FactureCeder.vue'),
  },
  {
    path: 'datos-personales',
    name: 'personal-data',
    component: PersonalData,
  },
  {
    path: 'editar-empresa/:companyId',
    name: 'edit-business',
    component: () => import( /* webpackChunkName: "edit-business" */ '@/views/dashboard/EditBusiness.vue'),
    props: true,
  },
  {
    path: 'documentos',
    name: 'mis-documents',
    component: () => import(/* webpackChunkName: "iou-and-certificates" */ '@/views/factoring/documents/Documents.vue'),
  },
  {
    path: 'finanzas',
    name: 'mis-finanzas',
    component: () => import(/* webpackChunkName: "iou-and-certificates" */ '@/views/factoring/Finances.vue'),
  },
  {
    path: 'cobranza',
    name: 'cobranza',
    component: () => import(/* webpackChunkName: "iou-and-certificates" */ '@/views/factoring/Debt.vue'),
  },
  {
    path: 'evaluacion-empresa',
    name: 'business-evaluation',
    component: () => import(/* webpackChunkName: "iou-and-certificates" */ '@/views/bciForm/BCIEvaluation.vue'),
  },

]